import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../api.js";
import { Button, Card, Field, Form, Input, Page, COLORS } from "../ui.js";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [espaceName, setEspaceName] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "sent" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      await api.post("/auth/formateur/signup", { email, displayName, espaceName });
      setStatus("sent");
    } catch (err) {
      setStatus("error");
      setErrorMsg(String(err));
    }
  }

  return (
    <div style={{ maxWidth: 480, margin: "10vh auto", padding: "0 20px" }}>
      <Page title="Créer mon Espace">
        <Card>
          {status === "sent" ? (
            <div>
              <p>
                Votre Espace est créé. Un lien de connexion vient d'être envoyé à <strong>{email}</strong>.
              </p>
              <p style={{ color: COLORS.muted, fontSize: 14 }}>
                En mode dev, le lien est imprimé dans la console du serveur API.
              </p>
            </div>
          ) : (
            <Form onSubmit={onSubmit}>
              <Field label="Nom de l'Espace">
                <Input
                  required
                  value={espaceName}
                  onChange={(e) => setEspaceName(e.target.value)}
                  placeholder="Studio Didier"
                  autoFocus
                />
              </Field>
              <Field label="Votre nom">
                <Input
                  required
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  placeholder="Didier Van Riet"
                />
              </Field>
              <Field label="Email">
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="moi@exemple.fr"
                />
              </Field>
              {errorMsg && <p style={{ color: COLORS.danger, fontSize: 13 }}>{errorMsg}</p>}
              <Button type="submit" disabled={status === "loading"}>
                {status === "loading" ? "Création…" : "Créer mon Espace"}
              </Button>
            </Form>
          )}
        </Card>
        <p style={{ textAlign: "center", color: COLORS.muted }}>
          Déjà un Espace ? <Link to="/login">Connectez-vous</Link>
        </p>
      </Page>
    </div>
  );
}
